import { curryN } from "../libs/ramda";
export default curryN(3, function (label, key, value) {
    var _a;
    return _a = {},
        _a[key] = { label: label, value: value },
        _a;
});
